export default {
    methods: {
        //adds selected tags to non conformité
        setTagsToAddSelection(tagsToAdd) {
            this.nonConformite.tags = tagsToAdd;
        },
    },
};
